class EfSearchInput {
    static get $inject() {
        return ["$scope"]
    }

    constructor(scope) {
        scope.$watch(() => this.searchQuery, () => this.setViewValue())
    }

    $onInit() {
        this.ngModelCtrl.$render = () => {
            this.searchQuery = this.ngModelCtrl.$viewValue
        }
    }

    setViewValue() {
        this.ngModelCtrl.$setViewValue(this.searchQuery)
    }
}

angular.module('eficienciaFiscalModule')
    .component('efSearchInput', {
        controller: EfSearchInput,
        bindings: {
            ngBlur: '&'
        },
        require: {
            ngModelCtrl: 'ngModel'
        },
        template: `
            <div>
                <input
                    class="form-control search-input"
                    ng-model="$ctrl.searchQuery"
                    ng-change="$ctrl.setViewValue()"
                    ng-blur="$ctrl.ngBlur({$event: $event})"
                    placeholder="Digite aqui para filtrar"/>
                <i class="fa fa-search icon-left"></i>
                <i class="fa fa-times icon-right" ng-if="$ctrl.searchQuery" ng-click="$ctrl.searchQuery = ''"></i>
            </div>
        `
    })
